var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20x20/Semi-Filled-Regular/Eye",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.685 9.72C4.032 6.24 6.804 4.5 10 4.5c3.196 0 5.968 1.74 8.315 5.22h0a.5.5 0 010 .56C15.968 13.76 13.196 15.5 10 15.5c-3.196 0-5.968-1.74-8.315-5.22h0a.5.5 0 010-.56z",
    id: "Path-2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "currentColor",
    cx: 10,
    cy: 10,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye20);
export default __webpack_public_path__ + "static/media/eye-20.c93ea04a.svg";
export { ForwardRef as ReactComponent };